import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, NOTIFICATION_TYPE, notifyMessageCreator } from 'Modules'
import { authSelector, authSlice } from 'Pages/auth'
import {
	rbidosCommonSlice,
	rbidosCommonNS,
	rbidosCommonApi,
	rbidosAgentSlice,
	DEFAULT_PARAMS_AGENT,
} from 'Pages/registry_business_access_neo'

export function* infotecsLogin(action: rbidosCommonNS.InfotecsLogin) {
	try {
		const { data } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(rbidosCommonApi.infotecsLogin, data)
		const { id } = yield* select(authSelector.getAuthDataSelector)
		yield* call(notifyMessageCreator, 'rbidos.infotex_login.success')
		yield* put(authSlice.actions.getUser({ id }))
		yield* put(rbidosAgentSlice.actions.getListAgent(DEFAULT_PARAMS_AGENT))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* deleteInfotecsLogin() {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(rbidosCommonApi.deleteInfotecsLogin)
		const { id } = yield* select(authSelector.getAuthDataSelector)
		yield* put(authSlice.actions.getUser({ id }))
		yield* put(rbidosAgentSlice.actions.getListAgent(DEFAULT_PARAMS_AGENT))
		yield* call(notifyMessageCreator, 'rbidos.infotex_logout.success')
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const errors = error?.data?.errors ?? []
		yield* call(notifyMessageCreator, 'rbidos.infotex_logout.error', {
			data: errors,
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	}
}

export function* rbidosCommonSaga() {
	yield* takeLatest(rbidosCommonSlice.actions.infotecsLogin.type, infotecsLogin)
	yield* takeLatest(rbidosCommonSlice.actions.deleteInfotecsLogin.type, deleteInfotecsLogin)
}
